import { useRef } from 'react'

type CardProps = {
  title: string
  description: string
  bgImg: string
}

export const Card = ({ title, description, bgImg }: CardProps) => {
  const cardRef = useRef<HTMLDivElement>(null)
  const titleRef = useRef<HTMLDivElement>(null)

  return (
    <div
      onMouseEnter={() => {
        cardRef.current?.classList.remove('animate-fade-out')
        titleRef.current?.classList.remove('animate-slide-up-title')

        cardRef.current?.classList.add('animate-fade-in')
        titleRef.current?.classList.add('animate-slide-down-title')
      }}
      onMouseLeave={() => {
        cardRef.current?.classList.remove('animate-fade-in')
        titleRef.current?.classList.remove('animate-slide-down-title')

        cardRef.current?.classList.add('animate-fade-out')
        titleRef.current?.classList.add('animate-slide-up-title')
      }}
      className="min-w-[292px] relative h-[364px] w-[292px] rounded-lg overflow-hidden"
    >
      <div
        style={{ backgroundImage: `url(${bgImg})` }}
        className={'z-10 flex items-center justify-center w-full h-full'}
      >
        <h3
          ref={titleRef}
          className="w-full font-bold text-[#DFEAF0] text-[32px] text-center font-openSans"
        >
          {title}
        </h3>
      </div>

      <div
        ref={cardRef}
        className="opacity-0 bg-[#CC3000] absolute top-0 bottom-0 left-0 right-0 z-20 flex items-center justify-center px-2"
      >
        <p className="text-[#DFEAF0] font-montserrat text-lg font-medium text-center">
          {description}
        </p>
      </div>
    </div>
  )
}
